export default "__VITE_ASSET__BRRy9pgx__"